import { register } from 'register-service-worker'
let Push = require("push.js")

let a = true;
if ( a ) {
  // if (process.env.NODE_ENV === 'production') {
  //register(`${process.env.BASE_URL}service-worker.js`, { => firebase-messaging-sw.js
  register(`${process.env.BASE_URL}firebase-messaging-sw.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      // alert("Nueva actualización disponible");
      // this.updated();
    },
    updated () {
      Push.create("Nueva actualización instalada", {
        body: "Haz clic aquí para actualizar.",
        // icon: '/icon.png',
        timeout: 180000,
        onClick: function () {
          this.close();
          location.href = "/login"
        }
    });
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
// import { register } from 'register-service-worker'


// let a = true;

// if (a){// (process.env.NODE_ENV === 'production') {
//   // register(`${process.env.BASE_URL}service-worker.jsfirebase-messaging-sw.js`, {
//   register(`${process.env.BASE_URL}firebase-messaging-sw.js`, {
//     ready () {
//       console.log(
//         'App is being served from cache by a service worker.\n' +
//         'For more details, visit https://goo.gl/AFskqB'
//       )
//     },
//     registered () {
//       console.log('Service worker has been registered.');
//     },
//     cached () {
//       console.log('Content has been cached for offline use.')
//     },
//     updatefound () {
//       console.log('New content is downloading.')
//     },
//     updated () {
//       console.log('New content is available; please refresh.')
//     },
//     offline () {
//       console.log('No internet connection found. App is running in offline mode.')
//     },
//     error (error) {
//       console.error('Error during service worker registration:', error)
//     }
//   })
// }



